export enum errors {
	ITEM_OUT_OF_STOCK = '_API_CANT_RESOLVE_FFMCENTER',
	ORDERITEM_MULTIPLE_TARIFFS = '_CSTMERR_ORDERITEM_MULTIPLE_TARIFFS',
	ORDERITEM_MULTIPLE_ACCESSORY_INSTALMENT = '_CSTMERR_ORDERITEM_MULTIPLE_ACCESSORY_INSTALMENT',
	ORDERITEM_MULTIPLE_TABLET_LAPTOP_INSTALMENT = '_CSTMERR_ORDERITEM_MULTIPLE_TABLET_LAPTOP_INSTALMENT',
	ORDERITEM_MIXED_COMMITMENT = '_CSTMERR_ORDERITEM_MIXED_COMMITMENT',
	SESSION_GENERIC_USER = 'USR.CWXFR0130E',
	MICROSOFT_ERROR = '_CSTMERR_ORDERITEM_MS_PRODUCT_NOT_AVAILIBLE',
}
